import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextareaComponent } from "../../templates/template-textarea/template-textarea.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-b11",
  imports: [TemplateTextareaComponent],
  templateUrl: "./prefix-b11.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-b11.component.less",
})
export class PrefixB11Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 7000;
    this.characters = ALLOWED_CHARACTERS["b11"];
  }
}
